// extracted by mini-css-extract-plugin
module.exports = {"container":"chattingPanel_container__2h4qb"};